export default __webpack_public_path__ + "static/media/POKONAJ_INNE_WYZWANIE.c41b9059.png";